import { tlResponseToUptimeString, TenantService, TenantFilter, Watch, ComponentService, BaseTLTableComponent, AxiosResponse, ObjectTypesHelper, BaseTLTableBase, tlISODateTimeToLocalNoSecondsString } from "../../../Infrastructure/CorBase/CoreBase";
	import { ReceiverService, ReceiverFilter } from "../../../Services/ContBase/AllConServices";


	export default class ReceiverListBase extends BaseTLTableComponent {
		receiverService: ReceiverService = new ReceiverService();
		componentService: ComponentService = new ComponentService();
		tenantService: TenantService = new TenantService();

		objectType: ObjectTypesHelper.ObjectTypeEnum = ObjectTypesHelper.ObjectTypeEnum.Receiver;
		modalContent: string = this.$t('receiver.messageQuestionMain').toString();
		right_Provisioning = false;
		//kdyz se jedna o seznam neprirazenych obrazovek
		notAssigned = false; 

		tenantsAll: [] = [];

		//co se zobrazni kdyz je prvek vybraný - lze vice sloupců
		names = ['name'];

		protected moreActionAddAllowBase(): boolean {
			//TODO slo by to jeste vic optimalizovat???
			
			if (this.notAssigned == false) {
				return this.canUpdate
					&& this.selectItems.length > 0
					&& this.selectItems
						.map(id => this.tableData.find(c => c.id == id))
						.filter(c => c != undefined)
						.every(c => c.isWaitingForAcceptProvisioning == true);
				/*
				for (var i = 0; i < this.selectItems.length; i++) {
					if (this.tableData.filter(c => c.id == this.selectItems[i] && c.isWaitingForAcceptProvisioning).length > 0) {
						return true && this.canUpdate;
					}
				}
				*/
			}
			return true;
		}

		goBackDetailModalBase(item: any, tableData: Array<any>): void {
			for (var i = 0; i < tableData.length; i++) {
				var changeItem = (tableData[i].tags as Array<any>).filter((c: any) => c.id == item.id);
				if (changeItem.length > 0) {
					changeItem[0].name = item.name;
					changeItem[0].color = item.color;
				}
			}
		}

		callActionClick() {
			if (this.itemsSelected) {
				let idList: number[] = this.getSelectedList();
				if (this.isDelete) {
					this.deleteSelected(idList);
				}
				else {
					if (this.notAssigned) {
						this.selectTenantBefore(idList);
					}
					else {
						this.addSelected(idList);
					}
				}
			}
			this.itemsSelected = null;
			(this.$refs.receiversTable as BaseTLTableBase).clearSelected();
		}

		showAllertToDeleteClickBase(itemsSelected: any) {
			this.showAlertBeforeActionClickBase(itemsSelected, this.$t('receiver.messageQuestionMain').toString(), true);
		}

		deleteSelected(idList: number[]) {
			if (idList.length > 0) {
				// VaPTODO - schovavame dialog, ktery vytvori base-tl-table, na zaklade jeho identifikatoru a pritom ani nevime, zda byl otevreny a ze se stale jmenuje stejne... a to neni dobre
				this.$bvModal.hide('popupDialog');
				this.isBusy = true;
				this.deleteItemsList = idList;
				super.deleteList();				
			}
		}

		protected deleteListServer(): Promise<AxiosResponse<any>> {
			return this.componentService.deleteList(this.deleteItemsList);
		}

		showAllertToAddClickBase(itemsSelected: any) {
				// z otheractionclick prijde cely objekt radku, ale tady chceme pouze jeho id
			let id = itemsSelected.id;
			if (id) {
				itemsSelected = id;
			}
			if (this.notAssigned) {
				this.selectTenantBefore(itemsSelected);
			}
			else {
				this.showAlertModalById('alertModalIdAdd');
			}
			//this.showAlertBeforeActionClickBase(itemsSelected, this.$t('receiver.messageQuestionMainAdd').toString(), false);
		}

		//TODO dát do předka
		addSelected(idList: any[]) {
			var onlyIdList = [];
			if (isNaN(idList[0])) {
				for (var i = 0; i < idList.length; i++) {
					onlyIdList.push(idList[i].id);
				}
			}
			else {
				onlyIdList = idList;
			}

			if (onlyIdList.length > 0) {
				this.isBusy = true;
				this.addList(onlyIdList).then(() => this.fetchData())
					.catch((error) => {
						var errorMessage = this.$t('receiver.errorAdd').toString();
						super.showAlertModalWithErrorMessageList(errorMessage);
						this.isBusy = false;
					});
			}
		}

		addList(idList: number[]): Promise<AxiosResponse<any>> {
			return this.componentService.acceptProvisionList(idList);
		}

		initAllTenant(): void {
			this.tenantService.getAllByFilter(new TenantFilter(false, true)).then(response => {
				this.tenantsAll = response.data;
			});
	}

		receiverTenantList: number[] = [];

		selectTenantBefore(idList: any[]) {
			var onlyIdList = [];
			onlyIdList.push(this.$store.state.idTenant);
			onlyIdList.push(idList);
		
			this.receiverService.updateTenantList(onlyIdList).then(c => {
				this.fetchData();
			});

			//TODO nevim proc nefunguje receiverService je null nevim proc
			//this.initAllTenant();
			//this.$bvModal.show('tenantModalReceiver');
		}


		//TODO zatim nepouzivam protoze receiverService se 
		selectedTenantItems(item:any) {
			var idList = [1,2];
			this.receiverService.updateTenantList( idList);
		}

		fieldsTenantModal = [
			{ key: 'identifier', label: this.$t('tenant.fieldIdentif'), trans: 'tenant.fieldIdentif', sortable: true, class: 'text-center', optional: false },
			{ key: 'name', label: this.$t('tenant.fieldName'), trans: 'tenant.fieldName', sortable: true, class: 'text-center', visible: true, optional: false },
			{ key: 'description', label: this.$t('tenant.fieldDescription'), trans: 'tenant.fieldDescription', sortable: true, class: 'text-center', visible: true, optional: false },
			{ key: 'creationDate', label: this.$t('tenant.fieldDate'), trans: 'tenant.fieldDate', sortable: true, class: 'text-center ', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x), visible: true, optional: false },

		];

		filtersTenantModal = [
			{ key: 'identifier', label: this.$t('tenant.filterIdentif'), trans: 'tenant.filterIdentif', selected: false, value: null, type: 'text', refItem: 'identifier' },
			{ key: 'name', label: this.$t('tenant.filterName'), trans: 'tenant.filterName', selected: false, value: null, type: 'text' },
			{ key: 'description', label: this.$t('tenant.filterDescription'), trans: 'tenant.filterDescription', selected: false, value: null, type: 'text' },
		];



		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let filter: ReceiverFilter;
			if (this.notAssigned) {
				filter = new ReceiverFilter(null, false, null, null, null, null, null, null, this.notAssigned, this.$store.state.isSuperUser);
			}
			else {
				filter = new ReceiverFilter(this.$store.state.idTenant, false, null, null, null, null, null, null, null, this.$store.state.isSuperUser);
			}
			return this.receiverService.getAllByFilter(filter);
		}

		//zatím nepotrebujeme
		fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			let filter: ReceiverFilter;
			if (this.notAssigned) {
				filter = new ReceiverFilter(null, false, null, null, null, null, null, null, this.notAssigned, this.$store.state.isSuperUser);
			}
			else {
				filter = new ReceiverFilter(this.$store.state.idTenant, false, null, null, null, null, null, null, null, this.$store.state.isSuperUser);
			}
			return this.receiverService.getAllByRefreshFilter(filter);
		}

		refreshItems(items: any[], refreshData: any[]): any[] {
			for (var i = 0; i < items.length; i++) {
				items[i].taskActual = refreshData[i].taskActual;
				items[i].idComponentStateNavigationName = refreshData[i].idComponentStateNavigationName;
				items[i].idComponentStateNavigationIdentifier = refreshData[i].idComponentStateNavigationIdentifier;
				items[i].idActiveTask = refreshData[i].idActiveTask;
				items[i].fileSumCheckTable = refreshData[i].fileSumCheckTable;

				items[i].connectionState = refreshData[i].connectionState;
				items[i].connectionStateError = refreshData[i].connectionStateError;
			}
			return items;
		}

		selectRowsBase(items: any) {
			this.selectItems = [];
			for (var i = 0; i < items.length; i++) {
				this.selectItems.push(items[i].id);
			}
		}

		prepareItems(items: any[]) {
			for (var i = 0; i < items.length; i++) {
				items[i].dateOfConfiguration = tlISODateTimeToLocalNoSecondsString(items[i].dateOfConfiguration);
			}
		}

		changeTagsBase(items: any, idLast: number) {
			var tagsItem = (this.tableData as Array<any>).filter(c => c.id == idLast)[0];
			tagsItem.tags = items;
		}

		setFields() {
			this.gridFields = [
				{ key: 'design', design: 'GridReceiver', label: 'Typ gridu co se zobrazi' },
				{ key: 'description1', data: 'idComponentStateNavigationName', label: this.$t('receiver.fieldStatus'), trans: 'receiver.fieldStatus', sortable: true },
				{ key: 'description', data: 'description', label: this.$t('receiver.fieldDescription'), trans: 'receiver.fieldDescription', sortable: true },
				{ key: 'description2', data: 'name' },
				{ key: 'name', data: 'name', sortable: true, label: this.$t('receiver.fieldName'), trans: 'receiver.fieldName' },
				{ key: 'tags', data: 'tags', action: 'filter'},
			];


			this.fields = [
		//		{ key: 'id', label: 'ddd', sortable: true, class: 'text-left', optional: true, visible: true },
				{ key: 'image', label: this.$t('receiver.fieldImage'), sortable: false, class: 'text-left columnImage', design: 'popupImage', trans: 'receiver.fieldImage' },
	//			{ key: 'fileSumCheckTable', label: 'FileSumCheck', trans: 'FileSumCheck', sortable: true, class: 'text-left ', optional: false, visible: true },
				{ key: 'name', label: this.$t('receiver.fieldName'), trans: 'receiver.fieldName', sortable: true, class: 'text-left ', optional: false, visible: true, design: 'detailReceiver' },
				{ key: 'idComponentStateNavigationName', label: this.$t('receiver.fieldStatus'), trans: 'receiver.fieldStatus', sortable: true, class: 'text-left helpWidth150', optional: false, visible: true, design: 'componentState' },				
				{ key: 'taskActual', label: this.$t('receiver.fieldActualPlay'), trans: 'receiver.fieldActualPlay', sortable: false, class: 'text-left', optional: true, visible: true, design: 'link' },
				{ key: 'tags', label: this.$t('receiver.fieldTags'), trans: 'receiver.fieldTags', sortable: false, class: 'text-left', design: 'tags', action: 'filter',  tooltip: 'tags'},

				{ key: 'description', label: this.$t('receiver.fieldDescription'), trans: 'receiver.fieldDescription', sortable: true, class: 'text-left', optional: true, visible: false },
				{ key: 'ipaddressText', label: this.$t('receiver.fieldIpAddress'), trans: 'receiver.fieldIpAddress', sortable: false, class: 'text-left', optional: true, visible: false },
				{ key: 'ipaddressVPNText', label: this.$t('receiverDetail.inputIPadressVPN'), trans: 'receiverDetail.inputIPadressVPN', sortable: false, class: 'text-left', optional: true, visible: false },
				{ key: 'ipaddressLocalText', label: this.$t('receiverDetail.inputIPadressLocal'), trans: 'receiverDetail.inputIPadressLocal', sortable: false, class: 'text-left', optional: true, visible: false },
			/*	{ key: 'port', label: this.$t('receiver.fieldPort'), trans: 'receiver.fieldPort', sortable: false, class: 'text-left', optional: true, visible: false },*/
				{ key: 'idDisplayOrientationText', label: this.$t('receiver.fieldOrientation'), trans: 'receiver.fieldOrientation', sortable: false, class: 'text-left', optional: true, visible: false },
				{ key: 'idVariantText', label: this.$t('receiver.fieldQuality'), trans: 'receiver.fieldQuality', sortable: false, class: 'text-left', optional: true, visible: false },
				{ key: 'dateOfConfiguration', label: this.$t('receiver.fieldDateOfConfiguration'), trans: 'receiver.fieldDateOfConfiguration', sortable: true, class: 'text-left', optional: true, visible: false},
				{ key: 'componentId', label: this.$t('receiverDetail.inputIdentificator'), trans: 'receiverDetail.inputIdentificator', sortable: true, class: 'text-left', optional: true, visible: false },
				{ key: 'programVersion', label: this.$t('receiverDetail.inputProgramVersion'), trans: 'receiverDetail.inputProgramVersion', sortable: true, class: 'text-left', optional: true, visible: false },

				{ key: 'idGroupNavigationName', label: this.$t('component.fieldGroup'), trans: 'component.fieldGroup', sortable: true, class: 'text-center', optional: true, visible: false },
				{ key: 'idTimeZoneText', label: this.$t('receiverDetail.inputTimeZone'), trans: 'receiverDetail.inputTimeZone', sortable: true, class: 'text-center', optional: true, visible: false },				
				{
					key: 'uptime', label: this.$t('receiverDetail.inputUptime'), trans: 'receiverDetail.inputUptime', sortable: true, class: 'text-left', optional: true, visible: false,
					sortByFormatted: this.prepareDataForSort,
					//formatter: (value: string) => value == null ? '0:0:0' : value 
					formatter: (value: string) => tlResponseToUptimeString(value) 
				},
				{ key: 'actions', label: this.$t('receiver.fieldActions'), trans: 'receiver.fieldActions', class: 'text-right', thClass: 'lastColumnTable' }
			];

			if (this.notAssigned) {
				this.fields = this.fields.filter((c: any) => c.key != 'tags' && c.key != 'taskActual');
			}
		};

		formatUptime(value: string) {
			if (value == '' || value == undefined) {
				return '';
			}
			var all = value.split(':');
			var first = all.length > 0? (all[0].length == 1 ? '0' + all[0] : all[0]): '';
			var sec = all.length > 1 ? (all[1].length == 1 ? '0' + all[1] : all[1]) : '';
			var third = all.length > 2 ? (all[2].length == 1 ? '0' + all[2] : all[2]) : '';
			return first + ':' + sec + ':' + third;
		}


		//*sortCompareOptions: { numeric: true, sensitivity: 'case', caseFirst: 'upper' },

		//filtry
		 setfilters(value: any) {
			 if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else {
					this.filters = [
						{ key: 'name', label: this.$t('receiver.filterName'), trans: 'receiver.filterName', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage },
						{ key: 'tags', label: this.$t('receiver.filterTag'), trans: 'receiver.filterTag', selected: false, value: null, type: 'multi', multiselect: true },
						{ key: 'programVersion', label: this.$t('receiverDetail.inputProgramVersion'), trans: 'receiverDetail.inputProgramVersion', selected: false, value: null, type: 'text' },
						{ key: 'ipaddressText', label: this.$t('receiver.fieldIpAddress'), trans: 'receiver.fieldIpAddress', selected: false, value: null, type: 'text' },
						{ key: 'ipaddressVPNText', label: this.$t('receiverDetail.inputIPadressVPN'), trans: 'receiverDetail.inputIPadressVPN', selected: false, value: null, type: 'text' },
						{ key: 'ipaddressLocalText', label: this.$t('receiverDetail.inputIPadressLocal'), trans: 'receiverDetail.inputIPadressLocal', selected: false, value: null, type: 'text' },

				];

				//skupinovy filtr
				var componentGroup = { key: 'ENU_COR_Component_State', label: 'AAA doplnit', selected: true, value: 'AAA doplnit', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: this.$t('receiver.filterGroupName'), trans: 'receiver.filterGroupName', isNegative: true };
				super.loadFiltersEnum(componentGroup);	
			}
		}

		prepareDataForSort(a: string, b: any, c: any) {
			if (a != null) {
				const timeA = a.split(':').map(Number);
				var hodnota = timeA[0] * 3600 + timeA[1] * 60 + timeA[2];
				return hodnota;
			}
		}

		protected selectedEditModalBase(item: any) {

			this.$bvModal.hide('editModal');
			this.$router.push({ name: 'ReceiverAdd', params: { ac: item.adoptionCode.toString() } });
		}


		protected addNewBase() {
			this.$bvModal.show('editModal');
		}

		//@ts-ignore
		@Watch('$store.state.currentLanguage')
		changeFieldsAfterChangeLanguage(value: boolean, oldValue: boolean) {
			this.setfilters(null);
			this.fetchData();
		}

	};